import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../../../api";
import { AxiosError } from "axios";

type DeleteGuicheServiceComplementParams = {
    id: number;
    guiche: number;
};

export function useAttendanceLocalDepartmentGuicheServiceComplementDelete() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    return useMutation<
        void,
        AxiosError<{ detail: string }>,
        DeleteGuicheServiceComplementParams
    >({
        mutationKey: ["attendance-local", "department", "guiche", "service-complement", "delete"],
        mutationFn: async ({ id, guiche }) => {
            await apisiseci.delete(`/cms/guiche_servico_complementar/${id}/`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { guiche },
            });
        },
        onSuccess: async () => {
            toast.success("Serviço complementar do guichê removido com sucesso!");

            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: ["attendance-local", "department", "guiche", "service-complement", "list"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ['internal-service', 'list'],
                })
            ]);
        },
        onError: (error) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });
}
